/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  AccountLookupResponse,
  CustomerDetailsResponse,
  CustomerHierarchyResponse,
  CustomerSearchResponse,
  CustomerSearchSimpleResponse,
  HttpValidationProblemDetails,
  ListCustomerParams,
  LookupAccountsParams,
  SearchCustomerParams,
  SelectedAccountConflict,
  SelectedAccountResponse,
  UpdateSelectedCustomerRequestModel
} from './data.schemas'




/**
 * Search for customers, searches in account data and location data, and returns all locations matching the search criteria
 */
export const searchCustomer = (
    segmentationId: number,
    params?: SearchCustomerParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomerSearchResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/search`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getSearchCustomerQueryKey = (segmentationId: number,
    params?: SearchCustomerParams,) => {
    return [`/api/segment/${segmentationId}/customers/search`, ...(params ? [params]: [])] as const;
    }

    
export const getSearchCustomerQueryOptions = <TData = Awaited<ReturnType<typeof searchCustomer>>, TError = AxiosError<unknown>>(segmentationId: number,
    params?: SearchCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomer>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchCustomerQueryKey(segmentationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCustomer>>> = ({ signal }) => searchCustomer(segmentationId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId),  staleTime: 900000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCustomer>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof searchCustomer>>>
export type SearchCustomerQueryError = AxiosError<unknown>

export const useSearchCustomer = <TData = Awaited<ReturnType<typeof searchCustomer>>, TError = AxiosError<unknown>>(
 segmentationId: number,
    params?: SearchCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomer>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSearchCustomerQueryOptions(segmentationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchSearchCustomer = async <TData = Awaited<ReturnType<typeof searchCustomer>>, TError = AxiosError<unknown>>(
 queryClient: QueryClient, segmentationId: number,
    params?: SearchCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomer>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getSearchCustomerQueryOptions(segmentationId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


/**
 * Search for customers, searches only in account data
 */
export const listCustomer = (
    segmentationId: number,
    params?: ListCustomerParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomerSearchSimpleResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/list`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getListCustomerQueryKey = (segmentationId: number,
    params?: ListCustomerParams,) => {
    return [`/api/segment/${segmentationId}/customers/list`, ...(params ? [params]: [])] as const;
    }

    
export const getListCustomerQueryOptions = <TData = Awaited<ReturnType<typeof listCustomer>>, TError = AxiosError<unknown>>(segmentationId: number,
    params?: ListCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomer>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomerQueryKey(segmentationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomer>>> = ({ signal }) => listCustomer(segmentationId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomer>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomer>>>
export type ListCustomerQueryError = AxiosError<unknown>

export const useListCustomer = <TData = Awaited<ReturnType<typeof listCustomer>>, TError = AxiosError<unknown>>(
 segmentationId: number,
    params?: ListCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCustomer>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getListCustomerQueryOptions(segmentationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Look up accounts a registration composite can be moved to. Searches customer number, name, name line 2, internal name and owner, and matches only on account data
 */
export const lookupAccounts = (
    segmentationId: number,
    params?: LookupAccountsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AccountLookupResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/lookup`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getLookupAccountsQueryKey = (segmentationId: number,
    params?: LookupAccountsParams,) => {
    return [`/api/segment/${segmentationId}/customers/lookup`, ...(params ? [params]: [])] as const;
    }

    
export const getLookupAccountsQueryOptions = <TData = Awaited<ReturnType<typeof lookupAccounts>>, TError = AxiosError<HttpValidationProblemDetails>>(segmentationId: number,
    params?: LookupAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupAccounts>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLookupAccountsQueryKey(segmentationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof lookupAccounts>>> = ({ signal }) => lookupAccounts(segmentationId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof lookupAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type LookupAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof lookupAccounts>>>
export type LookupAccountsQueryError = AxiosError<HttpValidationProblemDetails>

export const useLookupAccounts = <TData = Awaited<ReturnType<typeof lookupAccounts>>, TError = AxiosError<HttpValidationProblemDetails>>(
 segmentationId: number,
    params?: LookupAccountsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof lookupAccounts>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getLookupAccountsQueryOptions(segmentationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateSelectedCustomer = (
    segmentationId: number,
    updateSelectedCustomerRequestModel: UpdateSelectedCustomerRequestModel, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/selectedCustomer`,
      updateSelectedCustomerRequestModel,options
    );
  }



export const getUpdateSelectedCustomerMutationOptions = <TError = AxiosError<SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSelectedCustomer>>, TError,{segmentationId: number;data: UpdateSelectedCustomerRequestModel}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateSelectedCustomer>>, TError,{segmentationId: number;data: UpdateSelectedCustomerRequestModel}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSelectedCustomer>>, {segmentationId: number;data: UpdateSelectedCustomerRequestModel}> = (props) => {
          const {segmentationId,data} = props ?? {};

          return  updateSelectedCustomer(segmentationId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSelectedCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof updateSelectedCustomer>>>
    export type UpdateSelectedCustomerMutationBody = UpdateSelectedCustomerRequestModel
    export type UpdateSelectedCustomerMutationError = AxiosError<SelectedAccountConflict>

    export const useUpdateSelectedCustomer = <TError = AxiosError<SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSelectedCustomer>>, TError,{segmentationId: number;data: UpdateSelectedCustomerRequestModel}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateSelectedCustomer>>,
        TError,
        {segmentationId: number;data: UpdateSelectedCustomerRequestModel},
        TContext
      > => {

      const mutationOptions = getUpdateSelectedCustomerMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getSelectedCustomer = (
    segmentationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SelectedAccountResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/selectedCustomer`,options
    );
  }


export const getGetSelectedCustomerQueryKey = (segmentationId: number,) => {
    return [`/api/segment/${segmentationId}/customers/selectedCustomer`] as const;
    }

    
export const getGetSelectedCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getSelectedCustomer>>, TError = AxiosError<SelectedAccountConflict>>(segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelectedCustomer>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSelectedCustomerQueryKey(segmentationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSelectedCustomer>>> = ({ signal }) => getSelectedCustomer(segmentationId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId),  staleTime: 900000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSelectedCustomer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSelectedCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getSelectedCustomer>>>
export type GetSelectedCustomerQueryError = AxiosError<SelectedAccountConflict>

export const useGetSelectedCustomer = <TData = Awaited<ReturnType<typeof getSelectedCustomer>>, TError = AxiosError<SelectedAccountConflict>>(
 segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelectedCustomer>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSelectedCustomerQueryOptions(segmentationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetSelectedCustomer = async <TData = Awaited<ReturnType<typeof getSelectedCustomer>>, TError = AxiosError<SelectedAccountConflict>>(
 queryClient: QueryClient, segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelectedCustomer>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getGetSelectedCustomerQueryOptions(segmentationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


/**
 * Get details for the specified customer
 */
export const getCustomer = (
    segmentationId: number,
    accountId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomerDetailsResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}`,options
    );
  }


export const getGetCustomerQueryKey = (segmentationId: number,
    accountId: number,) => {
    return [`/api/segment/${segmentationId}/customers/${accountId}`] as const;
    }

    
export const getGetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getCustomer>>, TError = AxiosError<void>>(segmentationId: number,
    accountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerQueryKey(segmentationId,accountId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({ signal }) => getCustomer(segmentationId,accountId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId && accountId),  staleTime: 900000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomer>>>
export type GetCustomerQueryError = AxiosError<void>

export const useGetCustomer = <TData = Awaited<ReturnType<typeof getCustomer>>, TError = AxiosError<void>>(
 segmentationId: number,
    accountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCustomerQueryOptions(segmentationId,accountId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetCustomer = async <TData = Awaited<ReturnType<typeof getCustomer>>, TError = AxiosError<void>>(
 queryClient: QueryClient, segmentationId: number,
    accountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCustomerQueryOptions(segmentationId,accountId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


/**
 * Get the hierarchy the specified customer is a part of
 */
export const getCustomerHierarchy = (
    segmentationId: number,
    accountId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomerHierarchyResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/hierarchy`,options
    );
  }


export const getGetCustomerHierarchyQueryKey = (segmentationId: number,
    accountId: number,) => {
    return [`/api/segment/${segmentationId}/customers/${accountId}/hierarchy`] as const;
    }

    
export const getGetCustomerHierarchyQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerHierarchy>>, TError = AxiosError<string>>(segmentationId: number,
    accountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerHierarchy>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerHierarchyQueryKey(segmentationId,accountId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerHierarchy>>> = ({ signal }) => getCustomerHierarchy(segmentationId,accountId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId && accountId),  staleTime: 900000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerHierarchy>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerHierarchyQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerHierarchy>>>
export type GetCustomerHierarchyQueryError = AxiosError<string>

export const useGetCustomerHierarchy = <TData = Awaited<ReturnType<typeof getCustomerHierarchy>>, TError = AxiosError<string>>(
 segmentationId: number,
    accountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerHierarchy>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCustomerHierarchyQueryOptions(segmentationId,accountId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetCustomerHierarchy = async <TData = Awaited<ReturnType<typeof getCustomerHierarchy>>, TError = AxiosError<string>>(
 queryClient: QueryClient, segmentationId: number,
    accountId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerHierarchy>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getGetCustomerHierarchyQueryOptions(segmentationId,accountId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


/**
 * Get details for the specified customer
 */
export const getCustomerByExternalIdentifier = (
    segmentationId: number,
    externalIdentifier: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CustomerDetailsResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/by-external-id/${encodeURIComponent(String(externalIdentifier))}`,options
    );
  }


export const getGetCustomerByExternalIdentifierQueryKey = (segmentationId: number,
    externalIdentifier: string,) => {
    return [`/api/segment/${segmentationId}/customers/by-external-id/${externalIdentifier}`] as const;
    }

    
export const getGetCustomerByExternalIdentifierQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerByExternalIdentifier>>, TError = AxiosError<void>>(segmentationId: number,
    externalIdentifier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerByExternalIdentifier>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerByExternalIdentifierQueryKey(segmentationId,externalIdentifier);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerByExternalIdentifier>>> = ({ signal }) => getCustomerByExternalIdentifier(segmentationId,externalIdentifier, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId && externalIdentifier), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerByExternalIdentifier>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerByExternalIdentifierQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerByExternalIdentifier>>>
export type GetCustomerByExternalIdentifierQueryError = AxiosError<void>

export const useGetCustomerByExternalIdentifier = <TData = Awaited<ReturnType<typeof getCustomerByExternalIdentifier>>, TError = AxiosError<void>>(
 segmentationId: number,
    externalIdentifier: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerByExternalIdentifier>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCustomerByExternalIdentifierQueryOptions(segmentationId,externalIdentifier,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



